import { useState } from "react";
import useCustomersHook from "./useCustomersHook";
import useBranchId from "./useBranchId";
import { Customer } from "../utils/interfaces";
import { isPhoneNumber } from "../utils/helpers";

const useCustomerFinderHook = (orderUser, search) => {
  const branch = useBranchId();
  const [customers, setCustomers] = useState([]);
  const { order_user } = (orderUser as { order_user: Customer }) ?? {};
  const { getUsers } = useCustomersHook({
    branch,
    pageNumber: 1,
    pageSize: 100,
    filters: {
      filter: [
        {
          type: ["first_name", "last_name", "name"],
          values: [order_user?.name],
          operation: "contains",
          index: [],
          table: "filter",
        },
        {
          type: ["company_name"],
          values: [order_user?.company_name],
          operation: "contains",
          index: [],
          table: "filter",
        },
        {
          type: ["telephone"],
          values: [order_user?.telephone?.replace(/\D/g, "")],
          operation: "contains",
          index: [],
          table: "filter",
        },
        {
          type: ["email"],
          values: [order_user?.email],
          operation: "contains",
          index: [],
          table: "filter",
        },
        {
          type: ["zip_code"],
          values: [order_user?.zip_code],
          operation: "contains",
          index: [],
          table: "filter",
        },
        {
          type: ["city"],
          values: [order_user?.city],
          operation: "contains",
          index: [],
          table: "filter",
        },
        {
          type: ["street_name"],
          values: [order_user?.street_name],
          operation: "contains",
          index: [],
          table: "filter",
        },
        {
          type: ["house_number"],
          values: [order_user?.house_number],
          operation: "contains",
          index: [],
          table: "filter",
        },
        {
          type: ["house_number_extension"],
          values: [order_user?.house_number_extension],
          operation: "contains",
          index: [],
          table: "filter",
        },
      ].filter((item) => item.values[0] !== "" && item.values[0] !== undefined),
    },
  });

  const { getUsers: getUserBySearch } = useCustomersHook({
    branch,
    pageNumber: 1,
    pageSize: 100,
    filters: {
      filter: [
        {
          type: [
            "first_name",
            "last_name",
            "telephone",
            "name",
            "email",
            "zip_code",
            "city",
            "street_name",
            "house_number",
            "house_number_extension",
          ],
          values: [isPhoneNumber(search) ? search.replace(/\D/g, "") : search],
          operation: "contains",
          index: [],
          table: "filter",
        },
      ],
    },
  });

  const fetchCustomers = async (bySearchField: boolean) => {
    const { data } = await (
      bySearchField ? getUserBySearch : getUsers
    ).refetch();
    setCustomers(data?.order_users ?? []);
  };

  return {
    setCustomers,
    fetchCustomers,
    customers,
    isCustomerPending: getUsers.isFetching,
  };
};

export default useCustomerFinderHook;
